import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';

interface ServerLastCommunication {
  lastCommunicationDataTime: number | null;
}

const initialState: ServerLastCommunication = {
  lastCommunicationDataTime: null
};

const serverLastCommunicationSlice = createSlice({
  name: 'serverLastCommunication',
  initialState,
  reducers: {
    setServerLastCommunication: (state, action: PayloadAction<number | null>) => {
      state.lastCommunicationDataTime = action.payload;
    }
  }
});

export const { setServerLastCommunication } = serverLastCommunicationSlice.actions;

export const selectServerLastCommunication = (state: RootState): number | null =>
  state.serverLastCommunication.lastCommunicationDataTime;

export const serverLastCommunicationReducer = serverLastCommunicationSlice.reducer;
